import React from "react";
import { useParams } from "react-router";
import { useMutation } from "@apollo/client";
import { gql, useQuery } from "@apollo/client";
import { Form } from "react-final-form";
import { TextField, SelectField } from "@syos-music/form";

import { Grid, MenuItem, Container } from "@mui/material";

import Layout from "components/common/Layout";
import SaveFab from "components/common/SaveFab";
import IntlTextField from "components/form/IntlTextField";

const fragments = {
  orderState: gql`
    fragment Admin_OrderStatePage_OrderState on OrderState {
      id
      deleted
      locked
      name
      label
      clientState
      clientLabel {
        en
        fr
      }
    }
  `,
};

const QUERY = gql`
  query ($orderStateId: ID!) {
    orderState(id: $orderStateId) {
      id

      ...Admin_OrderStatePage_OrderState
    }
  }
  ${fragments.orderState}
`;

const MUTATION = gql`
  mutation (
    $id: ID!
    $name: String!
    $label: String!
    $clientState: OrderClientState!
    $clientLabel: IntlStringInput!
  ) {
    UpdateOrderState(
      orderStateId: $id
      name: $name
      label: $label
      clientState: $clientState
      clientLabel: $clientLabel
    ) {
      orderState {
        id

        ...Admin_OrderStatePage_OrderState
      }
    }
  }

  ${fragments.orderState}
`;

export default function OrderStatePage() {
  const { orderStateId } = useParams();
  const [updateOrderState] = useMutation(MUTATION);

  const { data, loading } = useQuery(QUERY, {
    variables: { orderStateId },
  });

  if (loading) return <Layout.Loading padded />;
  if (!data?.orderState) return <Layout.NotFound padded />;

  return (
    <Form
      onSubmit={(values) =>
        updateOrderState({ variables: values })
          .then(() => {})
          .catch(() => true)
      }
      initialValues={data?.orderState}
      keepDirtyOnReinitialize
    >
      {({ handleSubmit, pristine, submitting }) => (
        <form onSubmit={handleSubmit} noValidate autoComplete="off">
          <Layout.Toolbar fixed>
            <SaveFab
              onSave={handleSubmit}
              disabled={pristine}
              loading={submitting}
            />
          </Layout.Toolbar>

          <Container fixed sx={{ p: 2 }}>
            <Grid container>
              <Grid item xs={12}>
                <TextField
                  name="name"
                  required
                  disabled={data?.orderState.locked}
                  label="Nom machine"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  name="label"
                  required
                  label="Libellé"
                  helperText="Visible dans Lapidou"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <SelectField name="clientState" label="Êtat client" required>
                  <MenuItem value="NEW">new</MenuItem>
                  <MenuItem value="CONFIRMED">confirmed</MenuItem>
                  <MenuItem value="PRODUCTION">production</MenuItem>
                  <MenuItem value="PACKAGING">packaging</MenuItem>
                  <MenuItem value="SHIPPED">shipped</MenuItem>
                  <MenuItem value="FINISHED">finished</MenuItem>
                </SelectField>
              </Grid>

              <Grid item xs={12}>
                <IntlTextField
                  name="clientLabel"
                  required
                  label="Libellé"
                  helperText="Visible par les clients sur le site"
                />
              </Grid>
            </Grid>
          </Container>
        </form>
      )}
    </Form>
  );
}
